export default __webpack_public_path__ + "static/media/journeytray-graycurve.5ac2d774.svg";